<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid>
        <v-layout
          align="center"
          justify="center">
          <v-flex
            sm="8"
            md="4">
            <v-card class="loginContainer">
              <v-toolbar
                color="primary"
                dark
                flat>
                <v-toolbar-title>數位線上資融進件平台</v-toolbar-title>
              </v-toolbar>
              <v-card-text v-if="isRegister === false">
                <v-form
                  ref="form"
                  v-model="valid"
                  :lazy-validation="lazy">
                  <v-layout class="ma-2">
                    <v-flex>
                      <v-text-field
                        v-model="loginInfo.email"
                        :rules="emailRules"
                        label="帳號(Email)"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout class="ma-2">
                    <v-flex>
                      <v-text-field
                        v-model="loginInfo.password"
                        type="password"
                        :rules="passwordRules"
                        label="密碼"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-text v-if="isRegister === true">
                <v-form
                  ref="form"
                  v-model="valid"
                  :lazy-validation="lazy">
                  <v-layout class="ma-2" v-for="col in getDialogOptions"
                            :key="col.key">
                    <v-flex>
                      <v-text-field
                        v-model="registerInfo[col.key]"
                        :type="col.type"
                        :rules="col.rules"
                        :label="col.text"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-layout v-if="isRegister === false">
                  <v-btn style="width: 95%; margin: 0 auto;"
                         color="primary" :loading="loading" @click="loginEvent">登入</v-btn>
                </v-layout>
                <v-layout>
                  <v-btn style="width: 95%; margin: 0 auto;"
                         color="success" :loading="saveLoading" @click="registerEvent">註冊</v-btn>
                </v-layout>
                <v-layout v-if="isRegister === true">
                  <v-btn style="width: 95%; margin: 0 auto;"
                         color="primary" @click="backEvent">取消</v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>

          </v-flex>
        </v-layout>
        <!--彈出視窗-->
        <alert-view :visible="messageDialog.visible"
                    :title="messageDialog.title"
                    :content="messageDialog.content"
                    :show-cancel="false"
        @confirmEvent="confirmEvent"></alert-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';
import AlertView from '@/components/AlertView';
import { register } from '../service/user_service';

export default {
  name: 'login',
  components: { AlertView },
  comments: [
    AlertView,
  ],
  data() {
    return {
      valid: true,
      lazy: false,
      loading: false,
      saveLoading: false,
      loginInfo: {
        email: '',
        password: '',
      },
      isRegister: false,
      step: 0,
      registerInfo: {
        email: '',
        password: '',
        confirmPassword:'',
        displayName: '',
        cellphone: '',
        address: ''
      },
      emailRules: [
        v => !!v || 'E-mail是必填欄位',
        v => /.+@.+\..+/.test(v) || 'E-mail格式錯誤',
      ],
      passwordRules: [
        v => !!v || '密碼是必填欄位',
        v => v.length >= 6 || '密碼最少六位數',
      ],
      messageDialog: {
        visible: false,
        title: '',
        content: '',
      },

    };
  },
  computed: {
    getDialogOptions() {
      return [
        {key: 'email', text:'帳號(Email)', rules: this.emailRules, type:'text'},
        {key: 'password', text:'密碼', rules: this.passwordRules, type:'password'},
        {key: 'confirmPassword', text:'密碼確認', type:'password'},
        {key: 'displayName', text:'名稱', type:'text'},
        {key: 'cellphone', text:'手機號碼', type:'text'},
        {key: 'address', text:'地址', type:'text'}
      ]
    }
  },
  methods: {
    ...mapActions(['fetchUserInfo', 'login', 'logOut']),
    loginEvent() {
      this.loading = true;
      this.login({ account: this.loginInfo.email, password: this.loginInfo.password })
        .then(async (res) => {
          const user = await this.fetchUserInfo(res.user.uid);
          console.log(`login fetchUserInfo == ${JSON.stringify(user)}`);
          this.loading = false;
          if (!user.enable) {
            this.logOut();
            this.showDialog(true, '錯誤', '帳號未啟用，請聯絡客服人員');
          } else {
            // 登入成功
            this.$router.push('home/index');
          }
        }).catch((err) => {
          this.loading = false;
          console.log(`Login error ${err.code}`, err.message);
          this.showDialog(true, '錯誤', '登入失敗，請檢查帳號密碼！');
        });
    },
    showDialog(visible, title, content) {
      this.messageDialog.visible = visible;
      this.messageDialog.title = title;
      this.messageDialog.content = content;
    },
    confirmEvent() {
      this.messageDialog.visible = false;
    },
    async registerEvent(){
      if (this.isRegister) {
        if (this.registerInfo.email ==='') {
          this.showDialog(true, '錯誤', '請填寫密碼！');
          return;
        }

        if (this.registerInfo.email ==='') {
          this.showDialog(true, '錯誤', '請填寫電話號碼！');
          return;
        }

        if (this.registerInfo.password ==='' || this.registerInfo.confirmPassword === '') {
          this.showDialog(true, '錯誤', '請填寫密碼！');
          return;
        }
        if (this.registerInfo.password !== this.registerInfo.confirmPassword) {
          this.showDialog(true, '錯誤', '確認密碼不相同！請檢查！');
          return;
        }

        this.saveLoading = true;
        console.log(`register ${JSON.stringify(this.registerInfo)}`);
        const result = await register(this.registerInfo);
        console.log(`register result ${JSON.stringify(result)}`);
        this.saveLoading = false;
        if (result.statusCode === 0) {
          this.showDialog(true, '成功', '註冊成功，請等待帳戶審核！');
        } else {
          this.showDialog(true, '錯誤', '註冊失敗！');
        }
      }
      if (!this.isRegister) {
        this.isRegister = true;
      }
    },
    backEvent(){
      this.isRegister = false;
    }
  },
};
</script>

<style scoped>
  .loginContainer {
    /*padding-top: 5%;*/
    width: 390px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue